import type { components } from '@/api/schema'

/**
 * Contrato de agentes (fonte unica). O onboarding reexporta `AgentSummary`/`PlaygroundResult`
 * daqui para nao duplicar o shape — ver `features/onboarding/types.ts`. Nunca redeclarar estes
 * tipos a mao: `npm run api:types` (a partir de `artifacts/openapi/v1.json`) e a unica fonte.
 */

/** Resumo de um agente do tenant: id, nome, modo de operacao e status. */
export type AgentSummary = components['schemas']['AgentSummaryResponse']

/** Saida da mudanca de modo (200): o novo modo e o anterior, para feedback claro. */
export type AgentModeChange = components['schemas']['AgentModeResponse']

/** Saida de uma execucao do Playground (decisao + trace observavel). */
export type PlaygroundResult = components['schemas']['PlaygroundResponse']

/**
 * Modos de operacao do agente (espelha `Codout.Support.Domain.Agents.AgentMode`). O OpenAPI tipa
 * `mode` como `string` solto (o C# serializa via `ToString()`); estes literais dao seguranca de
 * tipo ao frontend, e qualquer valor novo do backend cai no fallback honesto de quem consome.
 */
export type AgentModeValue = 'ObserveOnly' | 'Suggest' | 'AutoReply'

/** Ordem de exibicao dos modos: do mais conservador (so observa) ao mais autonomo (responde sozinho). */
export const AGENT_MODES: readonly AgentModeValue[] = ['ObserveOnly', 'Suggest', 'AutoReply']

/** So o modo `AutoReply` exige confirmacao explicita + pre-requisitos (§24) para ser habilitado. */
export function requiresConfirmation(mode: AgentModeValue): boolean {
  return mode === 'AutoReply'
}

/** Type guard: o modo veio do backend como um dos tres conhecidos (nao um valor futuro/desconhecido). */
export function isKnownAgentMode(mode: string): mode is AgentModeValue {
  return mode === 'ObserveOnly' || mode === 'Suggest' || mode === 'AutoReply'
}
